// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"75edce6e","204":"58e308de","453":"53d587a1"}[chunkId] + ".chunk.js";
};